import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type CreateInvoiceChargeMutationVariables = Types.Exact<{
  input: Types.CreateInvoiceChargeCommand;
}>;


export type CreateInvoiceChargeMutation = { __typename?: 'MutationModel', projectCharges: { __typename?: 'ProjectChargesMutationModel', createInvoiceCharge: { __typename?: 'CreateProjectChargeResponse', projectChargeId?: number | null, errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const CreateInvoiceChargeDocument = gql`
    mutation CreateInvoiceCharge($input: CreateInvoiceChargeCommand!) {
  projectCharges {
    createInvoiceCharge(input: $input) {
      errors {
        argumentName
        message
      }
      projectChargeId
    }
  }
}
    `;
export type CreateInvoiceChargeMutationFn = Apollo.MutationFunction<CreateInvoiceChargeMutation, CreateInvoiceChargeMutationVariables>;

/**
 * __useCreateInvoiceChargeMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceChargeMutation, { data, loading, error }] = useCreateInvoiceChargeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvoiceChargeMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceChargeMutation, CreateInvoiceChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceChargeMutation, CreateInvoiceChargeMutationVariables>(CreateInvoiceChargeDocument, options);
      }
export type CreateInvoiceChargeMutationHookResult = ReturnType<typeof useCreateInvoiceChargeMutation>;
export type CreateInvoiceChargeMutationResult = Apollo.MutationResult<CreateInvoiceChargeMutation>;
export type CreateInvoiceChargeMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceChargeMutation, CreateInvoiceChargeMutationVariables>;